import { RequiredInjectionFacade as t } from "./required-injection-facade.js";
class e extends t {
  static KEY = Symbol("toast-service");
  constructor() {
    super(e.KEY);
  }
}
export {
  e as ToastServiceInjectionFacade
};
//# sourceMappingURL=toast-service-injection-facade.js.map
